






























































import {
    Vue,
    Prop,
    Inject,
    Component,
} from "@/shared/vuepack";
import Input from "@/shared/components/ui/Input.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { Validator } from "vee-validate";

@Component ({
    components: {
        Input,
        EmployerPhone
    }
})
export default class CompanyInfo extends Vue {
    @Inject() $validator: Validator;

    @Prop()
    profileInformation: any; // ProfileInformation;
    @Prop({default: false}) allowCustodianEdit: () => boolean;
    @Prop({default: false}) editDisabled: () => boolean;
    get isBankCustodianVisible (): boolean {
      return this.allowCustodianEdit &&
        this.profileInformation.allowedEmployerBankCustodians.length > 1;
    }
}

